module.exports = __webpack_public_path__ + "fonts/86ea14159a06f9894e9530e28fd33c77.svg";